/**
 *
 * ExitCheckoutPrompt
 *
 * */

import React from 'react';
import * as S from './style';

const ExitCheckoutPrompt = ({ close }) => {
    const stayIn = React.useCallback(
        (evt) => {
            evt.preventDefault();
            close();
        },
        [close]
    );

    return (
        <S.ExitCheckoutPrompt>
            Are you sure you want to return to your shopping cart?
            <S.Wrapper>
                <S.StayIn to="/checkout/" onClick={stayIn}>
                    Stay in checkout
                </S.StayIn>
                <S.LinkToCart to="/cart/" rel="nofollow" onClick={close}>
                    Return to cart
                </S.LinkToCart>
            </S.Wrapper>
        </S.ExitCheckoutPrompt>
    );
};

export default React.memo(ExitCheckoutPrompt);
